var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.3 42.25-.3-4.9h-2.8q-6.75 0-11.475-4.725T7 21.15q0-6.7 4.75-11.425Q16.5 5 23.25 5q3.35 0 6.2 1.225T34.425 9.6q2.125 2.15 3.35 5.1Q39 17.65 39 21.1q0 3.05-.875 6.075-.875 3.025-2.525 5.8T31.575 38.1Q29.2 40.45 26.3 42.25Zm1.9-4.15q3.95-3.35 6.25-7.85t2.3-9.15q0-6.05-3.875-9.95Q29 7.25 23.25 7.25q-5.85 0-9.925 4.075Q9.25 15.4 9.25 21.15q0 5.8 4.075 9.875T23.2 35.1h5Zm-4.9-5.9q.7 0 1.175-.475.475-.475.475-1.175 0-.7-.475-1.175Q24 28.9 23.3 28.9q-.7 0-1.175.475-.475.475-.475 1.175 0 .7.475 1.175.475.475 1.175.475Zm-1.1-6.4h2.05q0-1.2.45-2.025t1.8-2.175q1.2-1.2 1.725-2.25.525-1.05.525-2.3 0-2.1-1.475-3.5t-3.825-1.4q-1.95 0-3.45 1.025-1.5 1.025-2.25 2.725l1.85.75q.55-1.2 1.475-1.825T23.3 14.2q1.7 0 2.55.825.85.825.85 2.025 0 1-.55 1.925t-1.8 2.175q-1.3 1.35-1.725 2.275-.425.925-.425 2.375Zm.8-3.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatRound);
export default __webpack_public_path__ + "static/media/icon-chat-round.80e85c2efb8b63f16cc05f8ca3fdc900.svg";
export { ForwardRef as ReactComponent };